import firebaseConfig from '../../../../firebase-config.json';
export const AnalyticsConfig = {
  ga4: {
    measurementId: firebaseConfig?.result?.sdkConfig?.measurementId ?? null,
    enabled: Boolean(firebaseConfig?.result?.sdkConfig?.measurementId),
    debug: process.env.NODE_ENV === 'development',
    sendPageView: true,
  },

  clarity: {
    projectId: process.env.GATSBY_MS_CLARITY_ID ?? null,
    enabled: Boolean(process.env.GATSBY_MS_CLARITY_ID),
  },

  mixpanel: {
    token: process.env.GATSBY_MIXPANEL_TOKEN ?? null,
    enabled: Boolean(process.env.GATSBY_MIXPANEL_TOKEN),
    debug: process.env.NODE_ENV === 'development',
    trackPageView: true,
    persistence: 'localStorage',
    ignore_dnt: true,
  },

  // Global kill-switch: set GATSBY_ANALYTICS_ENABLED=false in .env to disable all
  globalEnabled: process.env.GATSBY_ANALYTICS_ENABLED !== 'false',
};
